import React, { createContext, useReducer, PropsWithChildren } from 'react'
import { PreventiveWithAsset } from '../Model'

export const PreventiveContext = createContext({})

const initialState: PreventiveWithAsset[] = []

interface Param {

}
type props = PropsWithChildren<Param>
const PreventiveReducer = (state: PreventiveWithAsset[], action: { type: string; payload: any }) => {
    switch (action.type) {
    case 'GET_Preventive':
        return action.payload || [] as PreventiveWithAsset[]
    case 'ADD_Preventive':
        return [...state, action.payload]
    default:
        return state
    }
}

export const PreventiveProvider = (props: props) => {
    const [PreventiveState, PreventiveDispatch] = useReducer(PreventiveReducer, initialState)

    const GetPreventive = (payload: PreventiveWithAsset[]) => {
        PreventiveDispatch({ type: 'GET_Preventive', payload })
    }

    const AddPreventive = (payload: PreventiveWithAsset) => {
        PreventiveDispatch({ type: 'ADD_Preventive', payload })
    }

    return (
        <PreventiveContext.Provider value={{ PreventiveState, GetPreventive, AddPreventive }}>
            {props.children}
        </PreventiveContext.Provider>
    )
}
